import Vue from "vue";
import VueRouter from "vue-router";

import Login from "../views/Login/Login.vue";

import Dashboard from "../views/Dashboard/Dashboard.vue";

import Venues from "../views/Venues/Venues.vue";
import CreateOrUpdateVenue from "../views/Venues/CreateOrUpdateVenue.vue";
import Logins from "../views/Users/Logins.vue";
import Partners from "../views/Partners/Partners.vue";
import Transactions from "../views/Transactions/Transaction.vue";
import OnlineWallet from "../views/Transactions/OnlineWallet.vue";

import ProfileSettings from "../views/Settings/ProfileSettings";
import UserSettings from "../views/Settings/UserSettings";
import Monitoring from "../views/Monitoring/Monitoring.vue";
import GlobalConfigurations from "../views/Settings/GlobalConfigurations";

import NotFoundPage from "../views/Errors/NotFound.vue";
import Forbidden from "../views/Errors/Forbidden.vue";
import Support from "@/views/Support/Support.vue";
import SalesTeam from "../views/SalesTeam/SalesTeam.vue";
import SalesTeamDetails from "../views/SalesTeam/SalesTeamDetails.vue";
import SalesDeals from "@/views/SalesTeam/SalesDeals.vue";
Vue.use(VueRouter);

const routes = [{
        name: "Root",
        path: "/",
        component: Login,
        meta: {
            item: null,
            title: "Login",
        },
    },

    {
        name: "Login",
        path: "/login",
        component: Login,
        meta: {
            item: null,
            title: "Login",
        },
    },

    {
        name: "Dashboard",
        path: "/dashboard",
        component: Dashboard,
        meta: {
            item: "dashboard",
            title: "Dashboard",
        },
    },

    {
        name: "Venues",
        path: "/venues",
        component: Venues,
        meta: {
            item: "venues",
            title: "Dashboard",
        },
    },
    {
        name: "CreateOrUpdateVenue",
        path: "/venue/:id?",
        component: CreateOrUpdateVenue,
        meta: {
            item: "venues",
            title: "Dashboard",
        },
    },

    {
        name: "Logins",
        path: "/logins",
        component: Logins,
        meta: {
            item: "logins",
            title: "Dashboard",
        },
    },

    {
        name: "Partners",
        path: "/partners",
        component: Partners,
        meta: {
            item: "partners",
            title: "Dashboard",
        },
    },
    {
        name: "Transactions",
        path: "/transactions",
        component: Transactions,
        meta: {
            item: "transactions",
            title: "Transactions",
        },
    },
    {
        name: "SalesTeam",
        path: "/sales-team",
        component: SalesTeam,
        meta: {
            item: "sales-team",
            title: "Sales Team",
        },
    },
    {
        name: "SalesTeamDeals",
        path: "/sales-team/deals",
        component: SalesDeals,
        meta: {
            item: "sales-team",
            title: "Sales Deals",
        },
    },
    {
        name: "SalesTeamDetails",
        path: "/sales-team-details/:id?",
        component: SalesTeamDetails,
        meta: {
            item: "sales-team",
            title: "Sales Team Details",
        },
    },
    {
        name: "OnlineWallet",
        path: "/online-wallet",
        component: OnlineWallet,
        meta: {
            item: "online-wallet",
            title: "online-wallet",
        },
    },
    {
        name: "ProfileSettings",
        path: "/settings/profile",
        component: ProfileSettings,
        meta: {
            item: "profile",
            title: "Profile",
        },
    },

    {
        name: "UserSettings",
        path: "/settings/users",
        component: UserSettings,
        meta: {
            item: "profile",
            title: "Profile",
        },
    },
    {
        name: "GlobalConfigurations",
        path: "/settings/global-configurations",
        component: GlobalConfigurations,
        meta: {
            item: "global-configurations",
            title: "global-configurations",
        },
    },

    {
        name: "Monitoring",
        path: "/monitoring",
        component: Monitoring,
        meta: {
            item: "Monitoring",
            title: "Monitoring",
        },
    },
    {
        name: "SupportTeam",
        path: "/support",
        component: Support,
        meta: {
            item: "support",
            title: "Support",
        },
    },

    //403
    {
        name: "Forbidden",
        path: "/forbidden",
        component: Forbidden,
        meta: {
            item: null,
            title: "Permission Denied",
        },
    },

    //404
    {
        name: "NotFound",
        path: "*",
        component: NotFoundPage,
        meta: {
            item: null,
            title: "Not FOund",
        },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;